import { c as _c } from "react/compiler-runtime";
type LoadRulesProps = {
  rules?: string | null;
};
const LoadRules = t0 => {
  const $ = _c(2);
  const {
    rules
  } = t0;
  let t1;
  if ($[0] !== rules) {
    t1 = rules ? <style>{rules}</style> : null;
    $[0] = rules;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export type { LoadRulesProps };
export default LoadRules;